export default __webpack_public_path__ + "static/media/BelgiumFlag.89911b08.png";